export default __webpack_public_path__ + "static/media/hero-cloud2.d8747154.svg";